const ALREADY_AVAILABLE = ["Sora", "Arial", "Helvetica", "Times New Roman", "Georgia", "Verdana", "Courier New"];
const loaded = {};

function loadGoogleFont(font) {
    if (ALREADY_AVAILABLE.indexOf(font) !== -1 || loaded[font]) {
        return;
    }

    const family = font.trim().replace(/\s+/g, "+");
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css?family=" + family + ":300,400,500,600,700&display=swap";
    document.head.appendChild(link);

    loaded[font] = true;
}

export function applyProgramFont(font) {
    const root = document.documentElement;
    const name = typeof font === "string" ? font.trim() : "";

    if (!name || name === "default") {
        root.style.removeProperty("--font-family");
        return;
    }

    loadGoogleFont(name);
    root.style.setProperty("--font-family", '"' + name + '", sans-serif');
}
